import { render, staticRenderFns } from "./DataRoom.vue?vue&type=template&id=083ef3b5&scoped=true"
import script from "./DataRoom.vue?vue&type=script&lang=ts"
export * from "./DataRoom.vue?vue&type=script&lang=ts"
import style0 from "./DataRoom.vue?vue&type=style&index=0&id=083ef3b5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083ef3b5",
  null
  
)

export default component.exports